import React, { createContext, useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

const zoomState = {
  currentTab: 0,
  sortByProperty: '',
};

const ZoomContext = createContext(zoomState);

const ZoomContextProvider = ({ children }) => {
  const [autoHeight, setAutoHeight] = useState(window.innerWidth < 1000);
  const [zoomOrResized, setZoomOrResized] = useState(0);
  const gridRef = useRef(null);
  const lineItemRef = useRef(null);
  const recommendedProgramsRef = useRef(null);
  const additionalGridRef = useRef(null);  

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1000) {
        setAutoHeight(true);
        if (gridRef.current) {
          gridRef.current?.api?.setGridOption('headerHeight', 20);
          gridRef.current?.api?.setGridOption('floatingFiltersHeight', 15);
        }
      } else {
        setAutoHeight(false);
        if (gridRef.current) {
          gridRef.current?.api?.setGridOption('headerHeight', undefined);
          gridRef.current?.api?.setGridOption('floatingFiltersHeight', undefined);
        }
      }
      setZoomOrResized(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    window.addEventListener('load', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('load', handleResize);
    };
  }, []);

  return (
    <ZoomContext.Provider
      value={{
        autoHeight,
        setAutoHeight,
        gridRef,
        lineItemRef,
        recommendedProgramsRef,
        additionalGridRef,
        zoomOrResized
      }}
    >
      {children}
    </ZoomContext.Provider>
  );
};

ZoomContextProvider.propTypes = {
  children: PropTypes.node,
};

export default ZoomContextProvider;
export { ZoomContext };
